import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { CLASS_META } from "./data";

function SpaceBadge({ s }) {
  const chip = "inline-flex items-center gap-1 text-[10px] font-bold rounded-full px-2 py-0.5 transition-colors";
  if (s.mode === "contact") {
    return (
      <Link to="/contact" className={`${chip} bg-[#0A2540]/8 text-[#0A2540] hover:bg-[#0A2540] hover:text-white`} data-testid="session-contact">
        <MessageCircle size={11} /> Contact us
      </Link>
    );
  }
  if (s.mode === "spaces-contact") {
    return (
      <Link to="/contact" className={`${chip} bg-[#10B981]/12 text-[#0E9F6E] hover:bg-[#10B981] hover:text-white`} data-testid="session-spaces-contact">
        <MessageCircle size={11} /> Spaces — contact us
      </Link>
    );
  }
  if (s.mode === "waitlist") {
    return (
      <Link to="/contact" className={`${chip} bg-[#EF4444]/12 text-[#DC2626] hover:bg-[#DC2626] hover:text-white`} data-testid="session-waitlist">
        Join waiting list
      </Link>
    );
  }
  // mode "spaces" (live availability) — or "book" (no count)
  if (s.spaces === null || s.spaces === undefined) return null;
  if (s.spaces <= 0) {
    return (
      <Link to="/contact" className={`${chip} bg-[#EF4444]/12 text-[#DC2626] hover:bg-[#DC2626] hover:text-white`} data-testid="session-waitlist">
        Full · Join waitlist
      </Link>
    );
  }
  const few = s.spaces <= 2;
  return (
    <span
      className={`${chip} ${few ? "bg-[#F59E0B]/15 text-[#B45309]" : "bg-[#10B981]/12 text-[#0E9F6E]"}`}
      data-testid="session-spaces"
    >
      {s.spaces} space{s.spaces > 1 ? "s" : ""}{few ? " left" : ""}
    </span>
  );
}

export function SessionCard({ s, index, bookingUrl }) {
  const color = CLASS_META[s.cls] || "#64748B";
  const bookable = (s.mode === "spaces" && typeof s.spaces === "number" && s.spaces > 0) || s.mode === "book";
  const inner = (
    <>
      <div className="flex items-start justify-between gap-2">
        <p className="font-heading font-bold text-[#0F172A] text-sm leading-none">{s.time}</p>
        <SpaceBadge s={s} />
      </div>
      <p className="mt-1.5 font-semibold text-sm leading-tight" style={{ color }}>{s.cls}</p>
      <p className="mt-1 text-[11px] font-medium text-[#94A3B8]">{s.category}{s.duration ? ` · ${s.duration}` : ""}</p>
    </>
  );
  const base = "block rounded-xl bg-white border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all p-3 border-l-4";
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: Math.min(index * 0.02, 0.3) }}
      data-testid="session-card"
    >
      {bookable ? (
        <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className={base} style={{ borderLeftColor: color }} data-testid="session-book-link">
          {inner}
        </a>
      ) : (
        <div className={base} style={{ borderLeftColor: color }}>{inner}</div>
      )}
    </motion.div>
  );
}
